import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = '/images/logo.png';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
  { label: 'Payment Info', path: '/payment-info' },
  { label: 'Franchise', path: '/franchise' },
];

export default function PublicNav({ activeItem }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white/70 backdrop-blur-xl border-b border-white/40 shadow-sm sticky top-0 z-50" data-testid="public-nav">
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img src={LOGO_URL} alt="ZAN Aqua" className="h-14 sm:h-16" />
          </Link>

          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm lg:text-base transition-colors duration-200 ${
                  link.label === activeItem
                    ? 'text-brand-accent font-medium'
                    : 'text-brand-primary hover:text-brand-accent'
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}

            {/*
            <Link
              to="/login"
              className="bg-brand-primary text-white hover:bg-brand-primary-hover px-6 py-2 border border-transparent shadow-sm transition-all duration-200 text-sm"
              data-testid="nav-login"
            >
              Login
            </Link>
            */}

          </div>

          <button
            className="md:hidden text-brand-primary"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-200 pt-4" data-testid="mobile-menu">
            <div className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`text-base py-2 transition-colors duration-200 ${
                    link.label === activeItem
                      ? 'text-brand-accent font-medium'
                      : 'text-brand-primary hover:text-brand-accent'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              {/* 
              <Link
                to="/login"
                onClick={() => setMobileMenuOpen(false)}
                className="bg-brand-primary text-white hover:bg-brand-primary-hover px-6 py-2 text-center transition-all duration-200"
              >
                Login
              </Link>
              */}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
